import { render, staticRenderFns } from "./reuterDetailPage.vue?vue&type=template&id=75670a62&scoped=true&"
import script from "./reuterDetailPage.vue?vue&type=script&lang=js&"
export * from "./reuterDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75670a62",
  null
  
)

export default component.exports